import { useEffect, useState } from 'react';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../../hooks/use-query-params';
import { useTagStaffStore } from '../../../../../../../store/use-tag-staff-store';

export const useJobTitlesModal = () => {
  const { fetchTags, tags: tag, isLoading, deleteTag } = useTagStaffStore();
  const { t } = useLang();
  const [isCreateOpen, setCreateOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);
  const [jobTitleId, setJobTitleId] = useState<number>();

  const { addQueryParams } = useQueryParams();

  const handleDeleteOpen = (jobTitleId: number) => {
    setJobTitleId(jobTitleId);
    setDeleteOpen(true);
  };

  useEffect(() => {
    fetchTags({ is_by_company: true, n: 1000, since_id: 0 });
  }, [fetchTags]);

  return {
    t,
    tag,
    onCloseCreateModal: () => setCreateOpen(false),
    onOpenCreateModal: () => setCreateOpen(true),
    isOpenCreateTag: isCreateOpen,
    onCloseDeleteModal: () => setDeleteOpen(false),
    onOpenDeleteModal: handleDeleteOpen,
    isOpenDeleteTag: isDeleteOpen,
    isLoading,
    jobTitleId,
    setJobTitleId,
    deleteTag,
    addQueryParams,
  };
};
